// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from '@/api'
import ElementUI from 'element-ui'
import cookies from './assets/js/cookies.js'
import common from './assets/js/common.js'
import { Popover } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/font/iconfont.css';
import './loading.css'
import "@/assets/style/base.css"
import "@/assets/style/common.css"


Vue.use(Popover);
Vue.prototype.$cookies = cookies;
Vue.prototype.$common = common;
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$http = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js